// extracted by mini-css-extract-plugin
export default {"commentSectionHeader":"Comments_commentSectionHeader__B1s0G"};